module.exports = __webpack_public_path__ + "static/media/6.c3ea3494.jpg";